import { FC, memo } from 'react';
import withBehaviors, { WithBehaviorsProps } from 'ia-react-core/~/hocs/withBehaviors';
import withShow, { WithShowProps } from 'ia-react-core/~/hocs/withShow';
import compose from '../../../utils/components/_compose';
import withValidationContext from '../../../hocs/form/_withValidationContext';
import withUniqueId from '../../../hocs/helpers/_withUniqueId';
import FormCol, { FormColProps } from './FormCol';

export * from './FormCol';

export default compose<FC<WithBehaviorsProps<FormColProps & WithShowProps>>>(
  withBehaviors,
  withShow,
  memo,
  withUniqueId('formColId'),
  withValidationContext,
)(FormCol);
